import { createFileRoute } from '@tanstack/react-router'
import { CmmsExplorerRoutePage } from 'pages/documents/CmmsExplorerRoutePage'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const searchSchema = z.object({
  [SEARCH_PARAM_ORG_ID]: z.string().optional(),
  [SEARCH_PARAM_SITE_ID]: z.string().optional(),
  collection: z.string().optional(),
  query: z.string().optional(),
  status: z.string().optional(),
  page: z.number().int().nonnegative().optional(),
  sort: z.string().optional(),
  descending: z.boolean().optional(),
})
function RouteComponent() {
  const search = Route.useSearch()
  return <CmmsExplorerRoutePage searchSiteId={search[SEARCH_PARAM_SITE_ID]} />
}
export const Route = createFileRoute('/documents/cmms')({
  component: RouteComponent,
  validateSearch: searchSchema,
  staticData: {
    title: 'CMMS Explorer',
    layout: { enableScrolling: false, enforceMaxWidth: false },
  },
})
